import {
  APP_NAME,
  metafieldFields,
  productFields,
  productVariantFields,
} from "../fields";
import {
  collectionFragment,
  mediaImageFragment,
  metaObjectProductFragment,
  variantMetafields,
  videoImageFragment,
} from "../fragments";
import {
  dropDateMetafield,
  releaseDateMetafield,
  thumbnailImagesMetafield,
} from "./product-metafields";
import type IQueryBuilderOptions from "gql-query-builder/build/IQueryBuilderOptions";

const productMetafields: Record<string, IQueryBuilderOptions[]> = {
  tune: [dropDateMetafield],
  yeseyesee: [],
  thisisneverthat: [releaseDateMetafield],
  khakis: [],
  sunlove: [],
  wellbeingexpress: [],
};

export const articleThemeMetafield = {
  operation: {
    name: 'metafield(namespace: "article", key: "theme")',
    alias: "articleTheme",
  },
  fields: [...metafieldFields],
  variables: {},
};

const thumbnailsName: Record<string, string> = {
  tune: '(namespace: "info", key: "thumbnail")',
  yeseyesee: '(namespace: "info", key: "thumbnail")',
  thisisneverthat: '(namespace: "info", key: "thumbnail")',
  khakis: '(namespace: "info", key: "thumbnail")',
  sunlove: '(namespace: "info", key: "thumbnail")',
  wellbeingexpress: '(namespace: "operation", key: "thumbnail")',
};

export const thumbnailMetafield = {
  operation: {
    name: `metafield${thumbnailsName[APP_NAME]}`,
    alias: "thumbnail",
  },
  fields: [
    ...metafieldFields,
    {
      operation: "references(first: 15)",
      fields: [{ edges: [{ node: [mediaImageFragment] }] }],
      variables: {},
    },
  ],
  variables: {},
};

const blogVideoName: Record<string, string> = {
  tune: '(namespace: "info", key: "video")',
  yeseyesee: '(namespace: "info", key: "video")',
  thisisneverthat: '(namespace: "operation", key: "video")',
  khakis: '(namespace: "info", key: "video")',
  sunlove: '(namespace: "info", key: "video")',
  wellbeingexpress: '(namespace: "info", key: "video")',
};

export const blogVideoMetafield = {
  operation: {
    name: `metafield${blogVideoName[APP_NAME]}`,
    alias: "video",
  },
  fields: [...metafieldFields, { reference: [videoImageFragment] }],
  variables: {},
};

export const collectionMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "collection")',
    alias: "collection",
  },
  fields: [...metafieldFields, { reference: [collectionFragment] }],
  variables: {},
};

const relatedProductsName: Record<string, string> = {
  tune: '(namespace: "operation", key: "related_products")',
  yeseyesee: '(namespace: "related-product", key: "list")',
  thisisneverthat: '(namespace: "operation", key: "related_products")',
  khakis: '(namespace: "related-product", key: "list")',
  sunlove: '(namespace: "operation", key: "related_products")',
  wellbeingexpress: '(namespace: "operation", key: "related_products")',
};

// Products 상품 메타필드
export const collectionProductMetafields: Record<
  string,
  IQueryBuilderOptions[]
> = {
  tune: [],
  yeseyesee: [],
  thisisneverthat: [],
  khakis: [],
  sunlove: [],
  wellbeingexpress: [thumbnailImagesMetafield],
};

export const relatedProductsMetafield = {
  operation: {
    name: `metafield${relatedProductsName[APP_NAME]}`,
    alias: "relatedProducts",
  },
  fields: [
    ...metafieldFields,
    {
      operation: "references(first: 100)",
      fields: [
        {
          edges: [
            {
              node: [
                {
                  operation: "Product",
                  fields: [
                    ...productFields,
                    ...productMetafields[APP_NAME],
                    ...collectionProductMetafields[APP_NAME],
                    {
                      operation: "variants(first: 100)",
                      fields: [
                        {
                          edges: [
                            {
                              node: [
                                ...productVariantFields,
                                ...variantMetafields[APP_NAME],
                              ],
                            },
                          ],
                        },
                      ],
                      variables: {},
                    },
                  ],
                  fragment: true,
                },
              ],
            },
          ],
        },
      ],
      variables: {},
    },
  ],
  variables: {},
};

export const articleMetafield = {
  operation: {
    name: `metafield(namespace: "operation", key: "article_items")`,
    alias: "articleProducts",
  },
  fields: [
    ...metafieldFields,
    {
      operation: "references(first: 100)",
      fields: [{ edges: [{ node: [metaObjectProductFragment] }] }],
      variables: {},
    },
  ],
  variables: {},
};

export const seasonMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "season")',
    alias: "season",
  },
  fields: [...metafieldFields],
  variables: {},
};
